<template>
  <div class="resource-credentials-form">
    <div class="resource-header">
      <label class="resource-title"> {{ $t('newProject.resources.resource') }} #{{ resourceNumber + 1 }}</label>
      <div class="resource-name">{{ resource.name }}</div>
    </div>
    <div class="resource-credentials">
      <div class="resource-credentials-header">
        <div class="resource-credentials-title">{{ $t('newProject.resources.credentials') }}</div>
        <label class="resource-credentials-add-button" @click="addCredentialsForResource">
          <span class="plus">+</span>{{ $t('newProject.resources.add') }}
        </label>
      </div>
      <resource-credentials-form-row
        v-for="(cred, index) in resource.credentials"
        :key="cred.name"
        :credential="cred"
        :index="index"
        @delete="deleteCurrentCred"
      />
    </div>
  </div>
</template>

<script>
import ResourceCredentialsFormRow from '@/components/ProjectDetails/credentials/ResourceCredentialsFormRow.vue';

export default {
  name: 'ResourceCredentialsForm',
  components: {
    ResourceCredentialsFormRow,
  },
  props: {
    resource: {
      type: Object,
      required: true,
    },
    resourceNumber: {
      type: Number,
      required: true,
    },
  },
  methods: {
    addCredentialsForResource() {
      this.resource.credentials.push({ username: '', password: '' });
    },
    deleteCurrentCred(index) {
      if (this.resource.credentials.length > 1) {
        this.resource.credentials.splice(index, 1);
      } else {
        this.resource.credentials = [
          {
            id: this.resource.credentials[index].id,
            username: '',
            password: '',
          },
        ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.resource-credentials-form {
  .resource-header {
    border-bottom: rem(1) solid rgba(231, 233, 236, 0.5);
    padding: rem(12) 0;

    .resource-title {
      text-transform: uppercase;
      color: var(--text-tertiary);
      font-size: rem(10);
      letter-spacing: rem(0.8);
      line-height: rem(10);
    }

    .resource-name {
      color: var(--text-primary);
      font-size: rem(14);
      font-weight: bold;
      letter-spacing: 0;
      line-height: rem(16);
    }
  }

  .resource-credentials {
    padding: rem(24) 0;

    .resource-credentials-header {
      display: flex;
      justify-content: space-between;

      .resource-credentials-add-button {
        color: var(--status-info);
        text-transform: uppercase;
        font-size: rem(12);
        font-weight: 500;
        letter-spacing: rem(1.07);
        line-height: rem(16);
        text-align: center;
        margin-right: rem(12);
        cursor: pointer;

        .plus {
          font-size: rem(16);
        }
      }

      .resource-credentials-title {
        color: var(--text-tertiary);
        text-transform: capitalize;
        font-size: rem(14);
        letter-spacing: 0;
        line-height: rem(16);
      }
    }
  }
}
</style>
